// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Button, Grid, Icon, Container } from 'semantic-ui-react'
import fire from '../config/Fire'
import SideBar from '../components/SideBar'
import AppInfo from '../components/AppInfo'
import MobileApp from '../components/MobileApp'

export default class Dashboard extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: true,
      data: []
    }
  }

  logout () {
    fire.auth().signOut()
  }

  componentDidMount = () => {
    window.scrollTo(0, 0)
    fire.auth().onAuthStateChanged((user) => {
      if (user) {
        let userUnderscore = user.email.replace(/\./g, '_')
        this.setState({ loggedIn: true, email: user.email, userUnderscore: userUnderscore })
        this.premium()
      } else {
        this.props.history.push('/')
      }
    })
  }

  premium = (e) => {
    fetch('https://murkstomstag.herokuapp.com/api/v1/premium/', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email: this.state.email
        // email: 'hafaiedhhager@gmail.com'
      })
    })
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        this.setState({ data: json })
        this.userData()
      })
      .catch((error) => {
        console.log(error)
        this.setState({ error: error.message, loading: false })
      })
  }

  userData = (e) => {
    fetch('https://murkstomstag.herokuapp.com/api/v1/user/data', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: this.state.userUnderscore
      })
    })
      .then((response) => {
        return response.json()
      })
      .then((obj) => {
        if ((obj.code = 200)) {
          this.setState({
            appname: obj.appname,
            description: obj.description,
            loading: false
          })
        } else {
          this.setState({
            loading: false,
            error: 'Internal Server Error |  code 500'
          })
        }
      })
      .catch((error) => {
        console.log(error)
        this.setState({ error: error.message, loading: false })
      })
  }

  edit = (e) => {
    this.setState({ loading: true, saved: false })

    e.preventDefault()
    this.setState({ loading: true })
    const objUpdate = {
      appname: this.state.appname,
      description: this.state.description
    }
    const cloneObjUpdate = { ...objUpdate }
    Object.keys(objUpdate).forEach((key) => {
      if (!cloneObjUpdate[key]) cloneObjUpdate[key] = null
    })
    fetch('https://murkstomstag.herokuapp.com/api/v1/info/edit', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: this.state.userUnderscore,
        cloneObjUpdate: cloneObjUpdate
      })
    })
      .then((response) => {
        if (response.status === 200) {
          this.setState({ loading: false, saved: true })
        } else {
          this.setState({ error: response.status, loading: false })
        }
      })
      .catch((error) => {
        console.log(error)
        this.setState({ error: error.message, loading: false })
      })
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value, edit: true })
  }

  render () {
    let { edit, saved, loading } = this.state
    return (
      <Container className='masterdiv'>
        <div className='mb center'>
          <h2>Dashboard</h2>
        </div>
        <Grid stackable verticalAlign='top' centered>
          <Grid.Column width={5}>
            <SideBar {...this.state} />
          </Grid.Column>
          <Grid.Column width={11}>

            <AppInfo {...this.state} handleChange={this.handleChange.bind(this)} />
            <Button
              onClick={this.edit}
              loading={loading}
              color='black'
              basic={saved}
              disabled={!edit}>
              <Icon name='save' />
              {!saved ? 'Save changes' : 'Saved successfully!'}
            </Button>
          </Grid.Column>
        </Grid>
         {/* <MobileApp /> */}
       
      </Container>
    )
  }
}
